import { useSelector } from "react-redux";
import { selectSubscriptionPermissions } from "store/features/subscription/subscriptionSelectors";

export const usePermissions = () => {
  const { features = [], permissions: rawPermissions = [] } = useSelector(
    (state) => state.subscription || { features: [], permissions: [] }
  );

  const permissions = useSelector(selectSubscriptionPermissions) || rawPermissions || [];

  const isFeatureEnabled = (featureKey) => {
    if (!featureKey) return true;
    const feat = features.find((f) => f.feature_key === featureKey);
    return feat ? feat.is_enabled === 1 : false;
  };

  const hasPermission = (permission, featureKey = null) => {
    if (featureKey && !isFeatureEnabled(featureKey)) return false;
    if (!permission) return false;
    if (permissions.includes(permission)) return true;
    const lowerPerm = String(permission).toLowerCase();
    return permissions.some(
      (perm) => String(perm).toLowerCase() === lowerPerm
    );
  };

  const hasAnyPermission = (permissionList) => {
    if (!Array.isArray(permissionList)) return false;
    return permissionList.some((perm) => hasPermission(perm));
  };

  const hasAllPermissions = (permissionList) => {
    if (!Array.isArray(permissionList)) return false;
    return permissionList.every((perm) => hasPermission(perm));
  };

  return { features, permissions, isFeatureEnabled, hasPermission, hasAnyPermission, hasAllPermissions };
};

export default usePermissions;

